import {Component, OnInit, ViewChild, Input, Output, EventEmitter} from '@angular/core';
import {Person} from './person';
import {Router} from '@angular/router';
import {PersonService} from './person.service';
import {NgForm} from '@angular/forms';
import {DelConfModalComponent} from '../../shared/delete-confirmation-modal.component';
import {ActivateConfModalComponent} from '../../shared/activate-confirmation-modal.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import {LoginService} from '../login/login.service';
import {LocaleCustomUnity} from '../../pipes/custom-locale.pipe';
import { ErrorBoxService } from '../../shared/error-box/error-box.service';
import {Response} from '@angular/http';

@Component({
  selector: 'app-person',
  templateUrl: './person.component.html',
  styleUrls: ['./person.component.scss']
})
export class PersonComponent implements OnInit {
  @Input() persons: any[];
  @Input() officeName: String;
  @Input() company: any;
  @Input() offices: any[];
  @Output() personDeleted = new EventEmitter<number>();
  @Output() personUpdated = new EventEmitter<any>();
  @Output() personConvertedToUser = new EventEmitter<any>();
  @Output() personCreated = new EventEmitter<any>();
  @Output() personActivated = new EventEmitter<any>();

  userData: any;
  showEditPersonOffcanvas: boolean = false;
  personToEdit: any = null;
  showCreateUserOffcanvas: boolean = false;
  contactToConvert: any = null;
  showAddPersonOffcanvas: boolean = false;
  showDisabledPerson: boolean = false;

  @ViewChild('newPersonForm')
  public newPersonForm: NgForm;

  public newPersonData = {
    name: null,
    surname: null,
    email: null,
    address: null,
    phone: null,
    office: null
  };

  constructor(
    private router: Router,
    private personService: PersonService,
    private modalService: NgbModal,
    private translate: TranslateService,
    private loginService: LoginService,
    private localeCustomUnity: LocaleCustomUnity,
    private errorBox: ErrorBoxService
  ) { }

  ngOnInit() {

   this.getUserData();
  }

  getPersons(): void {
    this.personService.getPersons()
      .then(persons => this.persons = persons);
  }

  openDeleteModal(person) {
    const modal = this.modalService.open(DelConfModalComponent, {
      backdrop: 'static',
      keyboard: false,
      // size: 'sm',
      windowClass: 'rmv-modal',
    });

    // Crear un mensaje más descriptivo
    const personName = person.name && person.surname
      ? `<b>${person.name} ${person.surname}</b>`
      : `<b>${person.name || 'Sin nombre'}</b>`;

    const personEmail = person.email ? ` (${person.email})` : '';

    modal.componentInstance.text = `${personName}${personEmail}`;
    modal.componentInstance.type = 'contacto';
    modal.result.then((result) => {
      if (result === 'Accept') {
        this.removePerson(person);
      } else { }
    });
  }

  removePerson(person: any): void {
    this.personService.deletePerson(person.id)
      .then(response => {
        // Solo emitir evento al componente padre, que se encarga de actualizar la lista
        this.personDeleted.emit(person);
        this.errorBox.success('Contacto eliminado correctamente.');
      })
      .catch(error => {
        if (error.status === 404) {
          this.errorBox.error(JSON.parse(error._body).error.message);
        }
      });
  }

  getUserData() {
    this.loginService.getUser()
      .then(user => {
        this.userData = user;
      });
  }

  openEditPersonOffcanvas(person: any) {
    this.personToEdit = person;
    this.showEditPersonOffcanvas = true;
  }

  closeEditPersonOffcanvas() {
    this.showEditPersonOffcanvas = false;
    this.personToEdit = null;
  }

  onPersonUpdated(updatedPerson: any) {
    // Actualizar la persona en la lista local
    const index = this.persons.findIndex(p => p.id === updatedPerson.id);
    if (index !== -1) {
      this.persons[index] = updatedPerson;
    }

    // Emitir evento al componente padre
    this.personUpdated.emit(updatedPerson);

    // Cerrar el offcanvas
    this.closeEditPersonOffcanvas();
  }

  convertToUser(person: any) {
    // Guardar el contacto para convertir y abrir el offcanvas
    this.contactToConvert = person;
    this.showCreateUserOffcanvas = true;
  }

  closeCreateUserOffcanvas() {
    this.showCreateUserOffcanvas = false;
    this.contactToConvert = null;
  }

  onUserCreated(eventData: any) {
    // El eventData ahora contiene { user: newUser, convertedContact: contactToConvert }
    const newUser = eventData.user;
    const convertedContact = eventData.convertedContact;

    if (convertedContact && convertedContact.id) {
      // Encontrar el contacto y reemplazarlo con la versión que tiene usuario
      const contactIndex = this.persons.findIndex(person => person.id === convertedContact.id);
      if (contactIndex !== -1) {
        // Reemplazar el contacto con una versión que incluye el usuario
        this.persons[contactIndex] = {
          ...convertedContact,
          user: {
            id: newUser.id,
            username: newUser.username,
            email: newUser.email,
            enabled: newUser.enabled,
            discount: newUser.discount,
            commission: newUser.commission
          }
        };
      }

      // Emitir evento al componente padre
      this.personConvertedToUser.emit({
        contactId: convertedContact.id,
        newUser: newUser,
        updatedPerson: this.persons[contactIndex]
      });
    }

    // Cerrar el offcanvas
    this.closeCreateUserOffcanvas();
  }

  openAddPersonOffcanvas() {
    this.showAddPersonOffcanvas = true;
  }

  closeAddPersonOffcanvas() {
    this.showAddPersonOffcanvas = false;
  }

  onPersonCreated(newPerson: any) {
    // Solo emitir evento al componente padre, que se encarga de actualizar la lista
    this.personCreated.emit(newPerson);

    // Cerrar el offcanvas
    this.closeAddPersonOffcanvas();
  }

  changeShowDisabledPerson() {
    this.showDisabledPerson = !this.showDisabledPerson;
  }

  openActivateModal(person) {
    const modal = this.modalService.open(ActivateConfModalComponent, {
      backdrop: 'static',
      keyboard: false,
      // size: 'sm',
      // windowClass: 'rmv-modal',
    });

    // Crear un mensaje más descriptivo
    const personName = person.name && person.surname
      ? `<b>${person.name} ${person.surname}</b>`
      : `<b>${person.name || 'Sin nombre'}</b>`;

    const personEmail = person.email ? ` (${person.email})` : '';

    modal.componentInstance.text = `${personName}${personEmail}`;
    modal.componentInstance.type = 'contacto';
    modal.result.then((result) => {
      if (result === 'Accept') {
        this.activatePerson(person);
      } else { }
    });
  }

  activatePerson(person: any): void {
    this.personService.activatePerson(person)
      .then(response => {
        // Solo emitir evento al componente padre, que se encarga de actualizar la lista
        this.personActivated.emit(person);
        this.errorBox.success('Contact activated successfully');
      })
      .catch(error => {
        if (error.status === 404) {
          this.errorBox.error(JSON.parse(error._body).error.message);
        }
      });
  }
}
